import React from 'react';
import { GatsbyImage } from "gatsby-plugin-image"
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import {colors} from '../../style/constants.js';
import { Link } from "gatsby";
import InnerLinkButton from '../svgs/buttons/InnerLinkButton';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    position: 'relative',
    marginBottom: 90,
    '&:last-child': {
      marginBottom: 0,
    },
    '& h3': {
      fontWeight: 700,
      color: colors.DARK_GREY,
    },
    
    '& a': {
      marginTop: 15
    },
    '& .left': {
      '& > div': {
        alignItems: 'flex-start',
        textAlign: 'left',
      },
      '& p': {
        paddingRight: 30
      },
    },
    '& .right': {
      flexFlow: 'row-reverse',
      '& > div': {
        textAlign: 'right',
      },
      '& p': {
        paddingLeft: 30
      },
      '& button': {
        marginLeft: 'auto'
      }
    },
    [theme.breakpoints.down('sm')]: {
      '& .left, .right': {
        flexFlow: 'column-reverse',
        '& h3': {
          marginTop: 30
        }
      },
      '& .right': {
        alignItems: 'flex-end',
        '& > :last-child': {
          justifyContent: 'flex-end'
        },
      }
    },
    '& video': {
      borderRadius: 10,
      width: '100%',
    }
  },
  list: {
    marginBottom: 30,
    '& p': {
      margin: '15px 0'
    },
  }
}));

const ListStyleOne = (props) => {

  const renderFunctions = () => {
    return props.items.node.functionalities.map((item, index) => {
      return (
        <p key={index}>{props.touchScreen ? item : item.name}</p>
      );
    });
  }

  const classes = useStyles();
  return (
    <Container className={classes.wrapper}>
      <Grid container className={props.align}>
        <Grid item xs={12} sm={6} md={7}>
          <h3>{props.items.node.name}</h3>
          <div className={classes.list}>
          {props.QM ? <p>{props.items.node.functionalities.functionalities}</p> :renderFunctions()}
          </div>
          <Link to={props.lang === 'en-CA' ? '/en/contact-us' : '/nous-parler'}><InnerLinkButton text={props.lang === 'en-CA' ? 'Ask for a demo' : 'Demandez une démo'} /></Link>
        </Grid>
        <Grid item container xs={12} sm={6} md={5}>
          <Grid item xs={12} sm={6} md={12}>
            {props.itemsAreVideos ? <video src={props.items.node.gif.file.url} autoPlay="autoPlay" muted={true} loop="loop"><track kind="captions" /></video> : <GatsbyImage image={props.items.node.gif.gatsbyImageData} alt={props.items.node.name} />}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ListStyleOne;